import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import bepvnw from "../../../components/tables/bep-vnw";

const data = [
  {
    les: "40",
    table: bepvnw
  }
];

export default () => (
  <TableSelector
    defaultChapter="40"
    data={data}
    title="Bepalend voornaamwoord"
  />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/bepalend-voornaamwoord.js